import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { dateFormat } from "@/utils/index.js";

/** 结算账户提现审核-分页 */
export function getWithdrawalAuditPageAPI(params) {
  return http({
    url: "/admin/store/withdraw/page",
    method: "get",
    params,
  });
}

/** 结算账户提现审核-提交 */
export function submitWithdrawalAuditAPI(data) {
  return http({
    url: "/admin/store/withdraw/review",
    method: "post",
    data,
  });
}

/** 结算账户提现审核-导出 */
export function exportWithdrawalAuditAPI(data) {
  showScreenLoading();
  return axios({
    method: "post",
    url: "/api/admin/store/withdraw/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then((res) => {
      hideScreenLoading();
      const blob = res.data;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      const filename = `结算账户提现审核${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch(() => {
      hideScreenLoading();
    });
}
